import { gameState } from "appworks/model/game-state";
import { builderManager } from "appworks/server/builders/builder-manager";
import { Connector } from "appworks/server/connectors/connector";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import * as Logger from "js-logger";
class CommsManager {

    public connector: Connector;

    private delayMs: number = 0;

    public request(request: any): Contract<void> {
        this.log("Outgoing: ", request);

        const gameplay = gameState.getCurrentGame();
        const builtRequest = builderManager.buildRequest(gameplay, request);

        return new Contract<void>((resolve) => {
            if (builtRequest) {
                this.connector.sendRequest(builtRequest)
                    .then((response) => {
                        this.response(request, response, resolve);
                    });
            } else {
                Logger.warn("Warning: request had no builder, so nothing was sent via connector");
                this.response(request, {}, resolve);
            }
        });
    }

    public requestRaw(request: any): Contract<void> {
        this.log("Outgoing raw: ", request);

        return new Contract<void>((resolve) => {
            this.connector.sendRequest(request).then((response) => {
                this.response(request, response, resolve);
            });
        });
    }

    public getDelay(): number {
        return this.delayMs;
    }

    public setDelay(delayMs: number) {
        this.delayMs = delayMs;
    }

    private response(request: any, response: any, resolve: Function) {
        new Sequence([
            () => this.delayMs > 0 ? Contract.getTimeoutContract(this.delayMs) : Contract.empty(),
            () => Contract.wrap(() => {
                this.log("Incoming: ", response);

                const gameplay = gameState.getCurrentGame();

                const builtRecords = builderManager.buildRecord(gameplay, request, response);

                try {
                    if (builtRecords) {
                        for (const builtRecord of builtRecords) {
                            gameplay.addRecord(builtRecord);
                        }
                    }
                    resolve(response);
                } catch (e) {
                    Logger.error(e);
                }
            })
        ]).execute();
    }

    /**
     * Log a message with colored label
     *
     * @param message {string}
     */
    private log(message: string, obj: any) {
        Logger.info("%c Comms Manager ", "background: #3f3; color: #666", message, obj);
    }
}

export const commsManager = new CommsManager();
